import axios from "axios";
import {
  GET_DATA_CHAT,
  GET_AGENT_STATE,
  GET_SOLVED_CHAT,
  GET_CHAT_AGENT,
  GET_SUMMARY_AGENT,
  GET_SUMMARY_RESULT,
  GET_SUMMARY_SOLVED,
  SET_DASHBOARD_ERROR,
} from "../Types/DashboardTypes";

const apiUrlDashboard = process.env.REACT_APP_API_URL + "dashboard/";

// export const getDataChat = () => {
//   return async (dispatch) => {
//     try {
//       const headerParameter = {
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//       };
//       const response = await axios.get(
//         `${apiUrlDashboard}getDataChat`,
//         headerParameter
//       );
//       if (response.data.status) {
//         dispatch({
//           type: GET_DATA_CHAT,
//           payload: response.data.data,
//         });
//       }
//     } catch (error) {
//       dispatch({
//         type: SET_DASHBOARD_ERROR,
//         payload: {
//           errorMessage:
//             "API getDataChat: " +
//             (error.response
//               ? error.response.data.error
//               : error.message
//               ? error.message
//               : "Failed to send!"),
//         },
//       });
//     }
//   };
// };

export const getAgentState = () => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(
        `${apiUrlDashboard}getAgentState`,
        headerParameter
      );
      if (response.data.status) {
        dispatch({
          type: GET_AGENT_STATE,
          payload: response.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: SET_DASHBOARD_ERROR,
        payload: {
          errorMessage:
            "API getAgentState: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const getDataChatSolved = () => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(
        `${apiUrlDashboard}getDataChatSolved`,
        headerParameter
      );
      if (response.data.status) {
        dispatch({
          type: GET_SOLVED_CHAT,
          payload: response.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: SET_DASHBOARD_ERROR,
        payload: {
          errorMessage:
            "API getDataChatSolved: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const getChatAgent = () => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(
        `${apiUrlDashboard}getChatAgent`,
        headerParameter
      );
      if (response.data.status) {
        dispatch({
          type: GET_CHAT_AGENT,
          payload: response.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: SET_DASHBOARD_ERROR,
        payload: {
          errorMessage:
            "API getChatAgent: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const getSummaryAgent = () => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(
        `${apiUrlDashboard}getSummaryAgent`,
        headerParameter
      );
      if (response.data.status) {
        dispatch({
          type: GET_SUMMARY_AGENT,
          payload: response.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: SET_DASHBOARD_ERROR,
        payload: {
          errorMessage:
            "API getSummaryAgent: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const getSummaryResult = () => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(
        `${apiUrlDashboard}getSummaryResult`,
        headerParameter
      );
      if (response.data.status) {
        dispatch({
          type: GET_SUMMARY_RESULT,
          payload: response.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: SET_DASHBOARD_ERROR,
        payload: {
          errorMessage:
            "API getSummaryResult: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const getSummarySolved = () => {
  return async (dispatch) => {
    try {
      const headerParameter = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };
      const response = await axios.get(
        `${apiUrlDashboard}getSummarySolvedByChannel`,
        headerParameter
      );
      if (response.data.status) {
        dispatch({
          type: GET_SUMMARY_SOLVED,
          payload: response.data.data,
        });
      }
    } catch (error) {
      dispatch({
        type: SET_DASHBOARD_ERROR,
        payload: {
          errorMessage:
            "API getSummaryResolved: " +
            (error.response
              ? error.response.data.error
              : error.message
              ? error.message
              : "Failed to send!"),
        },
      });
    }
  };
};

export const getDataCall = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}getdatacall`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDataCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDDataCall = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethddatacall`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDDataCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDataChat = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}getdatachat`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDataChat: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDataTicket = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}getdataticket`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDataTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDDataTicket = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethddataticket`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDDataTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getBusinessUnits = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getbusinessunits`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getBusinessUnits: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCampaignAgentTSS = async (businessUnitID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getcampaignagenttss?businessunitid=${businessUnitID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCampaignAgentTSS: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAgentTSS = async (businessUnitID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getagenttss?businessunitid=${businessUnitID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAgentTSS: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDashboardCallTSS = async (params) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getdashboardcalltss?campaignid=${params.campaignID}&leaderid=${params.leaderID}&startdate=${params.startDate}&enddate=${params.endDate}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDashboardCallTSS: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDashboardAgentStateByTLTSS = async (leaderID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getdashboardagentstatebytltss?leaderid=${leaderID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDashboardAgentStateByTLTSS: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDashboardStatusCallTSS = async (params) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getdashboardstatuscalltss?campaignid=${params.campaignID}&leaderid=${params.leaderID}&startdate=${params.startDate}&enddate=${params.endDate}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDashboardStatusCallTSS: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getCampaignAgent = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getcampaignagent`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getCampaignAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getTeamLeader = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getteamleader`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getTeamLeader: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDashboardBindCall = async (params) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getdashboardbindcall?campaignid=${params.campaignID}&filteragent=${params.filterAgent}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDashboardBindCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getTodayAssignment = async (params) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}gettodayassignment?campaignid=${params.campaignID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getTodayAssignment: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAssignmentCalled = async (params) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getassignmentcalled?campaignid=${params.campaignID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAssignmentCalled: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getAllAssignment = async (params) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getallassignment?campaignid=${params.campaignID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getAllAssignment: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDashboardAgentStateByTL = async (campaignID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getdashboardagentstatebytl?campaignid=${campaignID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDashboardAgentStateByTL: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getDashboardStatusCall = async (campaignID) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getdashboardstatuscall?campaignid=${campaignID}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getDashboardStatusCall: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getListDashboard = async (agentCode) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getlistdashboard?agentcode=${agentCode}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getListDashboard: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getWABAAgentSummary = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getwabaagentsummary`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getWABAAgentSummary: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getWABACallPermSummary = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getwabacallpermsummary`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getWABACallPermSummary: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getWABABroadcastSummary = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getwababroadcastsummary`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getWABABroadcastSummary: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getWABAInsightsAgent = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getwabainsightsagent`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getWABAInsightsAgent: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getWABAInsightsDaily = async (params) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getwabainsightsdaily?datestart=${params.dateStart}&dateend=${params.dateEnd}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getWABAInsightsDaily: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDAgentState = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethdagentstate`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDAgentState: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDDataAgentMonitoring = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethdatagentmonitoring`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDDataAgentMonitoring: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDDepartmentTicket = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethddepartmentticket`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDDepartmentTicket: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDTicketClosed = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethdticketclosed`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDTicketClosed: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDTicketCategoryResult = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethdticketcategoryresult`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDTicketCategoryResult: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getHDTicketTodaySummary = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}gethdtickettodaysummary`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getHDTicketTodaySummary: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getSosmedAgentPerformance = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}getsosmedagentperformance`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getSosmedAgentPerformance: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getSosmedTotalCaseHourly = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}getsosmedtotalcasehourly`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getSosmedTotalCaseHourly: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getSosmedTotalCaseSummary = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(`${apiUrlDashboard}getsosmedtotalcasesummary`, config);

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getSosmedTotalCaseSummary: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
          ? error.message
          : "Failed!"),
    };
  }
};

export const getChannelSummary = async (dateStart, dateEnd) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getchannelsummary?datestart=${dateStart}&dateend=${dateEnd}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getChannelSummary: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const getACDDateSummary = async (dateStart, dateEnd) => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getacddatesummary?datestart=${dateStart}&dateend=${dateEnd}`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getACDDateSummary: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};

export const getChannelAgentMonitoring = async () => {
  try {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };

    const response = await axios.get(
      `${apiUrlDashboard}getchannelagentmonitoring`,
      config
    );

    return response.data;
  } catch (error) {
    return {
      status: false,

      error:
        "API getChannelAgentMonitoring: " +
        (error.response && error.response.data
          ? error.response.data.error
          : error.message
            ? error.message
            : "Failed!"),
    };
  }
};
